import getColor from "@insite/mobius/utilities/getColor";
import getContrastColor from "@insite/mobius/utilities/getContrastColor";
import { contentSpacingStyles, transitionHoverStyles } from "@store/theme/common/mixins";
import { TYPOGRAPHY } from "@store/theme/design";
import breakpointMediaQueries, { mediaOptions } from "@store/utilities/breakpointMediaQueries";
import { css } from "styled-components";

export default {
    defaultProps: {
        cssOverrides: {
            pagination: css`
                justify-content: center;
                ${({ theme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                ${contentSpacingStyles(TYPOGRAPHY.spacing.base, TYPOGRAPHY.spacing.base)}
                            `,
                            null,
                            null,
                            css`
                                ${contentSpacingStyles(TYPOGRAPHY.spacing.large, TYPOGRAPHY.spacing.large)}
                            `,
                        ],
                        mediaOptions.min,
                    )}
            `,
            currentButton: css`
                background-color: ${getColor("primary")};
                color: ${getColor!("primary.contrast")};
            `,
            ellipsis: css`
                margin: 0 0.2em;
                cursor: default;
            `,
            linkList: css`
                margin: 0 !important;

                ul {
                    display: flex;
                    align-items: center;

                    li {
                        margin: 0 0.2em;
                        &:first-child {
                            margin-left: 0;
                        }
                        &:last-child {
                            margin-right: 0;
                        }

                        &:nth-child(2),
                        &:nth-last-child(2) {
                            ${({ theme }) =>
                                breakpointMediaQueries(
                                    theme,
                                    [
                                        null,
                                        css`
                                            display: none;
                                        `,
                                    ],
                                    mediaOptions.max,
                                )};
                        }
                    }
                }
            `,
            perPageSelect: css`
                display: none !important;
            `,
        },
        buttonProps: {
            shape: "rounded",
            sizeVariant: null,
            color: null,
            buttonType: null,
            activeMode: null,
            activeStyle: null,
            hoverMode: null,
            hoverStyle: null,
            hoverAnimation: null,
            typographyProps: {
                size: TYPOGRAPHY.size.base,
                weight: TYPOGRAPHY.weight.black,
                lineHeight: TYPOGRAPHY.lineHeight.small,
            },
            css: css`
                width: 32px !important;
                height: 32px;
                min-height: 0;
                border: 0;
                padding: 0;
                margin: 0;
                background-color: ${getColor("pagination")};
                color: ${getColor("text.main")};
                ${transitionHoverStyles("background-color", "color")}

                &:disabled {
                    opacity: 0.5;
                    color: ${getColor("common.disabled")};
                    cursor: default;
                }

                &:not(:disabled):hover {
                    background-color: ${getColor("pagination.hover")};
                }
            `,
        },
    },
};
